module.exports = __webpack_public_path__ + "static/media/logTutores.ec0e34a5.jpg";